<div class="dialog">
  <app-terms-services (closeModal)="closeDialog()"></app-terms-services>
</div>
